import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

export interface SellerSearchLoadApiAction extends Action {
    readonly start: number;
}

export const SELLER_SEARCH_LOAD_API_REQUEST = 'SELLER_SEARCH_LOAD_API_REQUEST';

export interface SellerSearchLoadApiRequestAction
    extends SellerSearchLoadApiAction,
        APIRequestAction {
    readonly type: typeof SELLER_SEARCH_LOAD_API_REQUEST;
}

export interface SellerSearchLoadNormalizedResponse extends NormalizedResponse {
    readonly result: {
        sellers: number[];
    };
}

export const SELLER_SEARCH_LOAD_API_SUCCESS = 'SELLER_SEARCH_LOAD_API_SUCCESS';

export interface SellerSearchLoadApiSuccessAction
    extends SellerSearchLoadApiAction,
        APISuccessAction<SellerSearchLoadNormalizedResponse> {
    readonly type: typeof SELLER_SEARCH_LOAD_API_SUCCESS;
    readonly total: number;
}

export const SELLER_SEARCH_LOAD_API_FAILURE = 'SELLER_SEARCH_LOAD_API_FAILURE';

export interface SellerSearchLoadApiFailureAction
    extends SellerSearchLoadApiAction,
        APIFailureAction {
    readonly type: typeof SELLER_SEARCH_LOAD_API_FAILURE;
}

export const sellerSearchLoadApi = {
    request: (start: number): SellerSearchLoadApiRequestAction => ({
        type: SELLER_SEARCH_LOAD_API_REQUEST,
        start,
    }),
    success: (
        start: number,
        total: number,
        response: SellerSearchLoadNormalizedResponse,
    ): SellerSearchLoadApiSuccessAction => ({
        type: SELLER_SEARCH_LOAD_API_SUCCESS,
        start,
        total,
        response,
    }),
    failure: (start: number, error: any): SellerSearchLoadApiFailureAction => ({
        type: SELLER_SEARCH_LOAD_API_FAILURE,
        start,
        error,
    }),
};

export const SELLER_SEARCH_LOAD = 'SELLER_SEARCH_LOAD';

export interface SellerSearchLoadAction extends SellerSearchLoadApiAction {
    readonly type: typeof SELLER_SEARCH_LOAD;
}

export const sellerSearchLoad = (start: number): SellerSearchLoadAction => ({
    type: SELLER_SEARCH_LOAD,
    start,
});
